import React from 'react';
import lazyWithReload from 'config/ChunkReload';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Auth } from 'modules/Core/Layout';

const Login = lazyWithReload(() =>
  import('modules/Auth/Login/Login.container')
);
const Forgot = lazyWithReload(() =>
  import('modules/Auth/ForgotPassword/ForgotPassword.container')
);
const NewPassword = lazyWithReload(() =>
  import('modules/Auth/NewPassword/NewPassword.container')
);

const AuthRoute = () => {
  const location = useLocation();

  const userLoggedOut = sessionStorage.getItem('userLoggedOut');

  const currentPath = location.pathname + location.search + location.hash;
  if (
    !userLoggedOut &&
    currentPath &&
    currentPath !== '/' &&
    !currentPath.startsWith('/auth/')
  ) {
    sessionStorage.setItem('redirectAfterLogin', currentPath);
  }

  return (
    <Auth>
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/forgot-password" element={<Forgot />} />
        <Route path="/auth/new-password" element={<NewPassword />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </Auth>
  );
};

export default AuthRoute;
